/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./error.vue.js?vue&type=template&id=249065c0&scoped=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./error.vue?vue&type=template&id=249065c0&scoped=true"
import script from "./error.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./error.vue?vue&type=script&lang=ts&setup=true"
export * from "./error.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./error.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./error.vue.postcss?vue&type=style&index=0&id=249065c0&prod&lang=postcss&scoped=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./error.vue?vue&type=style&index=0&id=249065c0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249065c0",
  null
  
)

export default component.exports